// import analyticsService from "@/services/analytics/analytics.service";
import { AnalyticsMeta } from './login.types';

import analyticsService from '@/services/analytics/analytics.service';
import sentryService from '@/services/sentry/sentry.service';

// TODO: this after-login logic should be used in dashboard as well - should we consolidate as a package? (see EH-6261)
export function setSentryAndAnalyticsAfterLogin(clinicianId: number, analyticsMeta: AnalyticsMeta) {
  sentryService.setUser(clinicianId);
  verifyAnalyticsMeta(analyticsMeta);
  analyticsService.analyticsSetup(analyticsMeta);
}

function verifyAnalyticsMeta(analyticsMeta: AnalyticsMeta) {
  if (
    !analyticsMeta.userId ||
    !analyticsMeta.institutionId ||
    !analyticsMeta.institutionName ||
    !analyticsMeta.releaseGroup
  ) {
    const error = new Error(`Missing analytics meta data: ${JSON.stringify(analyticsMeta)}`);

    sentryService.captureException(error);
  }
}
